module.exports = __webpack_public_path__ + "static/donate-with-paypal-button-2702dd6cfed32d8e369890a034f371b5.png";